import { Box }                      from '@chakra-ui/react';
import { Link }                     from 'react-router-dom';
import LoginForm                    from './forms/LoginForm';
import { Navigate }                 from 'react-router-dom';
import PageContainer                from '@/components/pageContainer/PageContainer';
import { Stack }                    from '@chakra-ui/react';
import { Text }                     from '@chakra-ui/react';
import authStore                    from '@/stores/authStore';
import { useLocation }              from 'react-router-dom';
import { useTranslation }           from 'react-i18next';
import useTranslations              from '@/hooks/useTranslations';

const LoginPage = () => {
    const { t } = useTranslation();
    const { getNavigationTranslation } = useTranslations();
    const isAuthenticated = authStore.isAuthenticated;
    const location = useLocation();
    const from = (location.state as { from?: { pathname: string } })?.from?.pathname || getNavigationTranslation('home', 'path');

    if (isAuthenticated) {
        return <Navigate to={from} state={{ from: location }} />;
    }
    
    return (
        <PageContainer type='public'>
            <Box
				display="flex"
				alignItems="center"
				height="100%"
				justifyContent="center"
			>
                <Box
					height="100%"
					maxWidth="600px"
					display="flex"
					flexDirection="column"
					justifyContent="space-between"
					padding="50px"
                    marginBottom="70px"
				>
                    <Box
                        display="flex"
						alignItems="center"
						justifyContent="center"
						height="100%"
                    >
                        <Stack 
                            gap="30px"
                        >
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems={{ base: "center", lg: "unset" }}
                                    gap="10px"
                                >
                                    <Text 
                                        className="poppins-semibold" 
                                        fontSize={{ base: 30, lg: 36 }}
                                    >
                                        {t('pages.login.label')}
                                    </Text>
                                    <Text textAlign="center" maxWidth={{ base: 300, lg: 450 }} fontSize="16px">{t('pages.login.mainText')}</Text>
                                </Box>
                                <LoginForm />
                        </Stack>
                    </Box>
                    <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            flexWrap="wrap"
                            paddingBottom="40px"
                            paddingTop="40px"
                        >
                            <Text>{t('pages.login.noAccount')}</Text>&nbsp;
                            <Link to={getNavigationTranslation('registration', 'path')}>
                                <Text fontWeight={600} textDecoration="underline">{t('pages.login.form.actions.signUp')}</Text>
                            </Link>
                    </Box>
                </Box>
            </Box>
        </PageContainer>
    )
}

export default LoginPage;